import { render } from "./SurgeryVitalSignModal.vue?vue&type=template&id=1380d24f&scoped=true"
import script from "./SurgeryVitalSignModal.vue?vue&type=script&lang=js"
export * from "./SurgeryVitalSignModal.vue?vue&type=script&lang=js"

import "./SurgeryVitalSignModal.vue?vue&type=style&index=0&id=1380d24f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1380d24f"]])

export default __exports__